<template>
  <v-container fluid>
    <v-row>
      <!-- ستون : پیش‌نمایش  -->
      <v-col cols="12" md="7" class="order-1 order-md-1">
        <custom-tabs
          :tab-items="[
            { text: 'جلوی کارت', icon: 'card-account-details-outline' },
            { text: 'پشت کارت', icon: 'credit-card-chip' },
          ]"
          grow
          v-model="activeTab"
        >
          <template v-slot:staticItems>
            <v-tab-item eager>
              <TemplatePositionEditor
                ref="frontEditor"
                title="موقعیت کیوآرکد بر روی جلوی کارت"
                :bgImage="frontBg"
                :qrImage="firstQrImage"
                :labelConfig="labelConfig"
                :labelPos.sync="frontLabelPos"
                v-model="frontConfig"
              />
            </v-tab-item>

            <v-tab-item eager>
              <TemplatePositionEditor
                ref="backEditor"
                title="موقعیت کیوآرکد بر روی پشت کارت"
                :bgImage="backBg"
                :qrImage="firstQrImage"
                :labelConfig="labelConfig"
                :labelPos.sync="backLabelPos"
                v-model="backConfig"
              />
            </v-tab-item>
          </template>
        </custom-tabs>
      </v-col>
      <v-col cols="12" md="5" class="order-2 order-md-2 pa-4 mb-4">
        <v-expansion-panels v-model="activePanels" accordion flat class="px-2">
          <v-expansion-panel class="mb-6">
            <v-expansion-panel-header class="text-right">
              <div class="d-flex justify-space-between align-center">
                <div>
                  <v-icon color="primary" class="me-2"
                    >mdi-card-multiple</v-icon
                  >
                  <span style="font-weight: bold">افزودن کارت nfc</span>
                </div>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="py-5">
              <custom-tabs
                v-model="activeTab"
                :tab-items="[
                  { text: 'پس‌زمینه جلو کارت', icon: 'image-outline' },
                  {
                    text: 'پس‌زمینه پشت کارت',
                    icon: 'image-multiple-outline',
                  },
                ]"
                grow
              >
                <template v-slot:staticItems>
                  <v-tab-item>
                    <QrPhotoSelector
                      :multiple="false"
                      :value="frontBgArray"
                      @input="setFrontBg"
                      :key="`front${qrImagesKey}`"
                    />
                  </v-tab-item>
                  <v-tab-item>
                    <QrPhotoSelector
                      :multiple="false"
                      :value="backBgArray"
                      @input="setBackBg"
                      :key="`back${qrImagesKey}`"
                    />
                  </v-tab-item>
                </template>
              </custom-tabs>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel class="mb-6">
            <v-expansion-panel-header class="text-right">
              <div class="d-flex justify-space-between align-center">
                <div>
                  <v-icon color="primary" class="me-2">mdi-qrcode</v-icon>
                  <span style="font-weight: bold">تنظیمات کیوارکد‌ها</span>
                </div>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="py-5">
              <!-- انتخاب و ویرایش کیوآرها -->
              <div class="mb-4">
                <div class="text-subtitle-2 mb-2">لیست کیوآرکدها</div>
                <QrPhotoSelector
                  :multiple="true"
                  v-model="qrImages"
                  :key="`qr${qrImagesKey}`"
                />

                <div v-if="qrImages.length > 0" class="mt-3">
                  <ImageEditorList v-model="qrImages" />
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel class="mb-6">
            <v-expansion-panel-header class="text-right">
              <div class="d-flex justify-space-between align-center">
                <div>
                  <v-icon color="primary" class="me-2">mdi-format-text</v-icon>
                  <span style="font-weight: bold">تنظیمات شناسه</span>
                </div>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="py-5">
              <LabelSettings v-model="labelConfig" />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <custom-popup
          v-model="dialogExport"
          :cons="{ title: 'تنطیمات خروجی', icon: 'export' }"
          hide-confirm
          max-width="1024"
        >
          <v-card class="pa-4" outlined>
            <v-row>
              <v-col cols="12" md="8" class="mt-4">
                <div class="mb-2">پیش‌نمایش خروجی نهایی (کارت اول)</div>

                <custom-tabs
                  v-model="previewTab"
                  :tab-items="[
                    { text: 'جلوی کارت', icon: 'card-account-details-outline' },
                    { text: 'پشت کارت', icon: 'credit-card-chip' },
                  ]"
                  grow
                  class="mb-2"
                >
                  <template v-slot:staticItems>
                    <!-- پیش‌نمایش جلوی کارت -->
                    <v-tab-item eager>
                      <v-card
                        outlined
                        class="d-flex justify-center align-center pa-2 mt-2"
                        style="background: #f5f5f5; min-height: 200px"
                      >
                        <v-progress-circular
                          v-if="isPreviewLoading"
                          indeterminate
                          color="primary"
                        ></v-progress-circular>
                        <v-img
                          v-else-if="finalPreviewUrlFront"
                          :src="finalPreviewUrlFront"
                          max-height="300"
                          contain
                        ></v-img>
                        <span v-else class="text-caption text-grey"
                          >لطفا پس‌زمینه و تنظیمات جلوی کارت را مشخص کنید</span
                        >
                      </v-card>
                    </v-tab-item>

                    <v-tab-item eager>
                      <v-card
                        outlined
                        class="d-flex justify-center align-center pa-2 mt-2"
                        style="background: #f5f5f5; min-height: 200px"
                      >
                        <v-progress-circular
                          v-if="isPreviewLoading"
                          indeterminate
                          color="primary"
                        ></v-progress-circular>
                        <v-img
                          v-else-if="finalPreviewUrlBack"
                          :src="finalPreviewUrlBack"
                          max-height="300"
                          contain
                        ></v-img>
                        <span v-else class="text-caption text-grey"
                          >لطفا پس‌زمینه و تنظیمات پشت کارت را مشخص کنید</span
                        >
                      </v-card>
                    </v-tab-item>
                  </template>
                </custom-tabs>
              </v-col>

              <v-col cols="12" md="4">
                <v-row>
                  <!-- ابعاد خروجی -->
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model.number="outputConfig.width"
                      type="number"
                      dense
                      outlined
                      hide-details
                      label="عرض خروجی (پیکسل)"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model.number="outputConfig.height"
                      dense
                      outlined
                      hide-details
                      type="number"
                      label="ارتفاع خروجی (پیکسل)"
                    ></v-text-field>
                  </v-col>

                  <!-- نحوه قرارگیری عکس -->
                  <v-col cols="12" md="12">
                    <v-select
                      v-model="outputConfig.fitMode"
                      :items="fitOptions"
                      outlined
                      dense
                      item-text="text"
                      item-value="value"
                      label="نحوه قرارگیری عکس"
                    ></v-select>
                  </v-col>

                  <!-- کیفیت خروجی -->
                  <v-col cols="12" md="12">
                    <v-slider
                      v-model="outputConfig.quality"
                      min="0.1"
                      max="1"
                      step="0.1"
                      thumb-label
                      label="کیفیت تصویر"
                    ></v-slider>
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      v-model="exportFormat"
                      :items="['png', 'jpg', 'psd', 'dxf']"
                      label="فرمت خروجی"
                      outlined
                      dense
                    ></v-select>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <div class="d-flex flex-row justify-space-between">
              <v-btn
                class="btn-delete rounded-lg"
                @click="dialogExport = false"
                :loading="isProcessing"
                ><v-icon>mdi-close</v-icon>
                انصراف
              </v-btn>
              <v-spacer />
              <v-btn
                class="btn-get-code rounded-lg"
                @click="processAndDownload"
                :loading="isProcessing"
                ><v-icon>mdi-plus</v-icon>
                ساخت و دانلود گروهی کارت‌ها
              </v-btn>
            </div>
          </v-card>
        </custom-popup>

        <v-btn
          class="btn-download rounded-lg"
          block
          @click="openExportModal"
          :loading="isProcessing"
          :disabled="!canExport"
          ><v-icon>mdi-plus-circle</v-icon>
          ساخت و دانلود گروهی کارت‌ها
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import QrPhotoSelector from "./QrPhotoSelector.vue";
import TemplatePositionEditor from "./TemplatePositionEditor.vue";
import ImageEditorList from "./ImageEditorList.vue";
import { writePsd } from "ag-psd";
import Drawing from "dxf-writer";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import LabelSettings from "./LabelSettings.vue";

export default {
  name: "BatchQrManager",
  components: {
    QrPhotoSelector,
    TemplatePositionEditor,
    ImageEditorList,
    LabelSettings,
  },
  data() {
    return {
      usePersianDigits: true,
      labelConfig: {
        enabled: false,
        fontSize: 40,
        color: "#000000",
        backgroundColor: "#00000000",
        fontFamily: "Arial",
        textValue: "",
        usePersianDigits: true,
      },
      frontLabelPos: { x: 50, y: 80 },
      backLabelPos: { x: 50, y: 80 },
      previewTab: 0,
      finalPreviewUrlFront: null,
      finalPreviewUrlBack: null,
      qrImagesKey: 0,
      finalPreviewUrl: null,
      isPreviewLoading: false,
      previewTimeout: null,
      dialogExport: false,
      outputConfig: {
        width: 1080,
        height: 1080,
        fitMode: "crop",
        quality: 0.9,
      },
      fitOptions: [
        { text: "برش عکس (Crop / Cover)", value: "crop" },
        { text: "کشیدن و فیکس کردن (Stretch / Fill)", value: "stretch" },
        { text: "نمایش کامل عکس با حاشیه (Contain / Fit)", value: "contain" },
      ],
      tabCard: 0,
      activePanels: [0, 1],
      activeTab: 0,
      isProcessing: false,
      exportFormat: "png",

      frontBg: "",
      backBg: "",
      qrImages: [],

      frontConfig: { shape: "rectangle", x: 10, y: 10, width: 25, height: 40 },
      backConfig: { shape: "rectangle", x: 10, y: 10, width: 25, height: 40 },
    };
  },
  computed: {
    frontBgArray() {
      return this.frontBg ? [{ url: this.frontBg }] : [];
    },
    backBgArray() {
      return this.backBg ? [{ url: this.backBg }] : [];
    },
    firstQrImage() {
      return this.qrImages.length > 0 && this.qrImages[0].url
        ? this.qrImages[0].url
        : "";
    },
    canExport() {
      return (this.frontBg || this.backBg) && this.qrImages.length > 0;
    },
  },
  watch: {
    "labelConfig.usePersianDigits": {
      handler() {
        this.updatePreviewSerial();
      },
    },
    outputConfig: {
      deep: true,
      handler() {
        this.triggerPreviewUpdate();
      },
    },
    frontConfig: {
      deep: true,
      handler() {
        this.triggerPreviewUpdate();
      },
    },
    frontBg() {
      this.triggerPreviewUpdate();
    },
    qrImages: {
      deep: true,
      handler() {
        this.updatePreviewSerial();
        this.triggerPreviewUpdate();
      },
    },
  },
  methods: {
    async generateDxfFromBase64(base64DataUrl) {
      const img = await this.loadImage(base64DataUrl);
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");

      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0);

      const d = new Drawing();
      d.setUnits('Pixels');

      const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = imgData.data;
      const step = 2; 

      for (let y = 0; y < canvas.height; y += step) {
        for (let x = 0; x < canvas.width; x += step) {
          const index = (y * canvas.width + x) * 4;
          const r = data[index];
          const g = data[index + 1];
          const b = data[index + 2];
          const a = data[index + 3];

          if (a > 128 && (r + g + b) / 3 < 128) {
            d.drawRect(x, -y, x + step, -(y + step));
          }
        }
      }
      return d.toDxfString();
    },
    generateDxfString(bgWidth, bgHeight, config, labelData) {
  const d = new Drawing();
  d.setUnits('Pixels');

  if (config) {
    const qrW = bgWidth * (config.width / 100);
    const qrH = bgWidth * (config.height / 100); 
    const qrX = (config.x / 100) * bgWidth;
    const qrY = (config.y / 100) * bgHeight;
    
    const dxfY = bgHeight - qrY; 
    
    d.drawRect(qrX, dxfY - qrH, qrX + qrW, dxfY);
  }

  if (labelData && labelData.enabled) {
    const tX = (labelData.pos.x / 100) * bgWidth;
    const tY = (labelData.pos.y / 100) * bgHeight;
    const dxfTY = bgHeight - tY;
    
    d.drawText(
      tX, 
      dxfTY, 
      labelData.fontSize, 
      0, 
      labelData.text, 
      'center'
    );
  }
  return d.toDxfString();
},
    extractNumberFromFileName(nameOrUrl, usePersian = true) {
      if (!nameOrUrl) return "";

      let filename = nameOrUrl.split("/").pop().split("\\").pop();
      if (filename.startsWith("blob:")) return "";

      filename = filename.replace(/\.[^/.]+$/, "");
      const match = filename.match(/\d+/g);
      let extractedNumber = match ? match.join("") : "";

      if (usePersian) {
        const persianDigits = [
          "۰",
          "۱",
          "۲",
          "۳",
          "۴",
          "۵",
          "۶",
          "۷",
          "۸",
          "۹",
        ];
        return extractedNumber.replace(/\d/g, (x) => persianDigits[x]);
      }

      return extractedNumber;
    },

    updatePreviewSerial() {
      if (this.qrImages && this.qrImages.length > 0) {
        const nameToUse = this.qrImages[0].name || this.qrImages[0].url;
        this.labelConfig.textValue = this.extractNumberFromFileName(
          nameToUse,
          this.labelConfig.usePersianDigits,
        );
      } else {
        this.labelConfig.textValue = "";
      }
    },

    openExportModal() {
      this.dialogExport = true;
      this.triggerPreviewUpdate();
    },
    resetAllData() {
      this.finalPreviewUrlFront = null;
      this.finalPreviewUrlBack = null;
      this.previewTab = 0;
      this.frontBg = "";
      this.backBg = "";
      this.qrImages = [];
      this.finalPreviewUrl = null;
      this.frontConfig = {
        shape: "rectangle",
        x: 10,
        y: 10,
        width: 25,
        height: 40,
      };
      this.backConfig = {
        shape: "rectangle",
        x: 10,
        y: 10,
        width: 25,
        height: 40,
      };

      this.outputConfig = {
        width: 1080,
        height: 1080,
        fitMode: "crop",
        quality: 0.9,
      };
      this.exportFormat = "png";
      this.activeTab = 0;
      const frontEditor = Array.isArray(this.$refs.frontEditor)
        ? this.$refs.frontEditor[0]
        : this.$refs.frontEditor;
      if (frontEditor) {
        frontEditor.customLayers = [];
      }
      const backEditor = Array.isArray(this.$refs.backEditor)
        ? this.$refs.backEditor[0]
        : this.$refs.backEditor;
      if (backEditor) {
        backEditor.customLayers = [];
      }
      this.qrImages = [];
      this.frontBgArray = [];
      this.backBgArray = [];
      this.qrImagesKey += 1;
    },

    triggerPreviewUpdate() {
      clearTimeout(this.previewTimeout);
      this.previewTimeout = setTimeout(() => {
        this.updateFinalPreview();
      }, 500);
    },
    async updateFinalPreview() {
      if (!this.frontBg && !this.backBg) return;
      this.isPreviewLoading = true;

      try {
        const qrToUse = this.qrImages.length > 0 ? this.qrImages[0].url : null;
        const labelDataFront = {
          ...this.labelConfig,
          text: this.labelConfig.textValue,
          pos: this.frontLabelPos,
        };

        const labelDataBack = {
          ...this.labelConfig,
          text: this.labelConfig.textValue,
          pos: this.backLabelPos,
        };
        // ۱. تولید پیش‌نمایش جلوی کارت
        if (this.frontBg) {
          let frontLayers = [];
          if (this.$refs.frontEditor) {
            frontLayers = Array.isArray(this.$refs.frontEditor)
              ? this.$refs.frontEditor[0].getCustomLayers()
              : this.$refs.frontEditor.getCustomLayers();
          }
          const base64Front = await this.generateStandardImageBase64(
            this.frontBg,
            qrToUse,
            this.frontConfig,
            "image/jpeg",
            frontLayers,
            labelDataFront,
          );
          this.finalPreviewUrlFront = await this.applyOutputFormatting(
            base64Front,
          );
        } else {
          this.finalPreviewUrlFront = null;
        }

        // ۲. تولید پیش‌نمایش پشت کارت
        if (this.backBg) {
          let backLayers = [];
          if (this.$refs.backEditor) {
            backLayers = Array.isArray(this.$refs.backEditor)
              ? this.$refs.backEditor[0].getCustomLayers()
              : this.$refs.backEditor.getCustomLayers();
          }
          const base64Back = await this.generateStandardImageBase64(
            this.backBg,
            qrToUse,
            this.backConfig,
            "image/jpeg",
            backLayers,
            labelDataBack,
          );
          this.finalPreviewUrlBack = await this.applyOutputFormatting(
            base64Back,
          );
        } else {
          this.finalPreviewUrlBack = null;
        }
      } catch (error) {
        console.error("Error generating preview", error);
      } finally {
        this.isPreviewLoading = false;
      }
    },
    async applyOutputFormatting(sourceBase64, mimeType = "image/jpeg") {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          const config = this.outputConfig;

          canvas.width = config.width;
          canvas.height = config.height;

          if (mimeType === "image/jpeg") {
            ctx.fillStyle = "#ffffff";
            ctx.fillRect(0, 0, canvas.width, canvas.height);
          }

          let dx = 0,
            dy = 0,
            dw = canvas.width,
            dh = canvas.height;

          if (config.fitMode === "stretch") {
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          } else if (config.fitMode === "crop") {
            const scale = Math.max(
              canvas.width / img.width,
              canvas.height / img.height,
            );
            dw = img.width * scale;
            dh = img.height * scale;
            dx = (canvas.width - dw) / 2;
            dy = (canvas.height - dh) / 2;
            ctx.drawImage(img, dx, dy, dw, dh);
          } else if (config.fitMode === "contain") {
            const scale = Math.min(
              canvas.width / img.width,
              canvas.height / img.height,
            );
            dw = img.width * scale;
            dh = img.height * scale;
            dx = (canvas.width - dw) / 2;
            dy = (canvas.height - dh) / 2;
            ctx.drawImage(img, dx, dy, dw, dh);
          }

          resolve(canvas.toDataURL(mimeType, config.quality));
        };

        img.onerror = reject;
        img.src = sourceBase64;
      });
    },

    setFrontBg(arr) {
      this.frontBg = arr && arr.length > 0 ? arr[0].url : "";
      this.activeTab = 0;
    },
    setBackBg(arr) {
      this.backBg = arr && arr.length > 0 ? arr[0].url : "";
      this.activeTab = 1;
    },

    loadImage(src) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = src;
      });
    },

    async generateStandardImageBase64(
      bgUrl,
      qrUrl,
      config,
      format = "image/png",
      customLayers = [],
      labelData,
    ) {
      const bgImg = await this.loadImage(bgUrl);
      const canvas = document.createElement("canvas");

      canvas.width = bgImg.width;
      canvas.height = bgImg.height;
      const ctx = canvas.getContext("2d");

      ctx.drawImage(bgImg, 0, 0, canvas.width, canvas.height);

      for (const layer of customLayers) {
        if (!layer.src) continue;
        const layerImg = await this.loadImage(layer.src);

        const lW = (layer.widthPercent / 100) * canvas.width;
        const lH = (layer.heightPercent / 100) * canvas.height;
        const cx = (layer.cxPercent / 100) * canvas.width;
        const cy = (layer.cyPercent / 100) * canvas.height;

        ctx.save();
        ctx.translate(cx, cy);
        if (layer.angle) {
          ctx.rotate((layer.angle * Math.PI) / 180);
        }
        ctx.drawImage(layerImg, -lW / 2, -lH / 2, lW, lH);
        ctx.restore();
      }
      // 3. رسم کیوآرکد
      if (qrUrl && config) {
        const qrImg = await this.loadImage(qrUrl);

        // const qrW = (config.width / 100) * canvas.width;
        // const qrH = (config.height / 100) * canvas.height;
        let qrW = canvas.width * (config.width / 100);
        const qrAspectRatio = qrImg.width / qrImg.height;
        let qrH = qrW / qrAspectRatio;
        const qrX = (config.x / 100) * canvas.width;
        const qrY = (config.y / 100) * canvas.height;

        ctx.save();
        if (config.shape === "circle") {
          ctx.beginPath();
          const radius = Math.min(qrW, qrH) / 2;
          ctx.ellipse(
            qrX + qrW / 2,
            qrY + qrH / 2,
            radius,
            radius,
            0,
            0,
            2 * Math.PI,
          );
          ctx.clip();
        }
        ctx.drawImage(qrImg, qrX, qrY, qrW, qrH);
        ctx.restore();
      }
      if (labelData && labelData.enabled) {
        const scaleX = labelData.pos.scaleX || 1;
        const scaleY = labelData.pos.scaleY || 1;
        ctx.save();
        ctx.fillStyle = labelData.color;
        ctx.font = `${labelData.fontSize}px ${labelData.fontFamily}`;
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        const tX = (labelData.pos.x / 100) * canvas.width;
        const tY = (labelData.pos.y / 100) * canvas.height;
        const tAngle = labelData.pos.angle || 0;
        ctx.translate(tX, tY);
        ctx.rotate((tAngle * Math.PI) / 180);
        ctx.scale(scaleX, scaleY);

        if (
          labelData.backgroundColor &&
          labelData.backgroundColor !== "transparent"
        ) {
          const metrics = ctx.measureText(labelData.text);
          const textWidth = metrics.width;
          const textHeight = labelData.fontSize;
          const padding = 8;
          ctx.fillStyle = labelData.backgroundColor;
          ctx.fillRect(
            -textWidth / 2 - padding / 2,
            -textHeight / 2 - padding / 2,
            textWidth + padding,
            textHeight + padding,
          );
        }
        ctx.fillStyle = labelData.color;
        ctx.fillText(labelData.text, 0, 0);

        ctx.restore();
      }

      return canvas.toDataURL(format);
    },

    async generatePsdBuffer(
      bgUrl,
      qrUrl,
      config,
      customLayers = [],
      labelData,
    ) {
      const bgImg = await this.loadImage(bgUrl);
      const canvasWidth = bgImg.width;
      const canvasHeight = bgImg.height;

      const children = [];

      // 1. لایه پس‌زمینه
      const bgCanvas = document.createElement("canvas");
      bgCanvas.width = canvasWidth;
      bgCanvas.height = canvasHeight;
      bgCanvas
        .getContext("2d")
        .drawImage(bgImg, 0, 0, canvasWidth, canvasHeight);
      children.push({
        name: "Background",
        canvas: bgCanvas,
        left: 0,
        top: 0,
      });

      // 2. لایه‌های سفارشی
      for (let i = 0; i < customLayers.length; i++) {
        const layer = customLayers[i];
        if (!layer.src) continue;
        const layerImg = await this.loadImage(layer.src);

        const lW = (layer.widthPercent / 100) * canvasWidth;
        const lH = (layer.heightPercent / 100) * canvasHeight;
        const cx = (layer.cxPercent / 100) * canvasWidth;
        const cy = (layer.cyPercent / 100) * canvasHeight;

        const layerCanvas = document.createElement("canvas");
        layerCanvas.width = canvasWidth;
        layerCanvas.height = canvasHeight;
        const layerCtx = layerCanvas.getContext("2d");

        layerCtx.save();
        layerCtx.translate(cx, cy);
        if (layer.angle) {
          layerCtx.rotate((layer.angle * Math.PI) / 180);
        }
        layerCtx.drawImage(layerImg, -lW / 2, -lH / 2, lW, lH);
        layerCtx.restore();

        children.push({
          name: `Custom Layer ${i + 1}`,
          canvas: layerCanvas,
          left: 0,
          top: 0,
        });
      }

      // 3. لایه کیوآرکد
      if (qrUrl && config) {
        const qrImg = await this.loadImage(qrUrl);

        // const qrW = (config.width / 100) * canvasWidth;
        // const qrH = (config.height / 100) * canvasHeight;
        let qrW = canvasWidth * (config.width / 100);
        const qrAspectRatio = qrImg.width / qrImg.height;
        let qrH = qrW / qrAspectRatio;
        const qrX = (config.x / 100) * canvasWidth;
        const qrY = (config.y / 100) * canvasHeight;

        const qrCanvas = document.createElement("canvas");
        qrCanvas.width = qrW;
        qrCanvas.height = qrH;
        const qrCtx = qrCanvas.getContext("2d");

        if (config.shape === "circle") {
          qrCtx.beginPath();
          qrCtx.ellipse(qrW / 2, qrH / 2, qrW / 2, qrH / 2, 0, 0, 2 * Math.PI);
          qrCtx.clip();
        }
        qrCtx.drawImage(qrImg, 0, 0, qrW, qrH);

        children.push({
          name: "QR Code",
          canvas: qrCanvas,
          left: qrX,
          top: qrY,
        });
      }
      //4. لایه متن
      if (labelData && labelData.enabled) {
        const scaleX = labelData.pos.scaleX || 1;
        const scaleY = labelData.pos.scaleY || 1;
        const textCanvas = document.createElement("canvas");
        textCanvas.width = canvasWidth;
        textCanvas.height = canvasHeight;
        const textCtx = textCanvas.getContext("2d");

        textCtx.fillStyle = labelData.color;
        textCtx.font = `${labelData.fontSize}px ${labelData.fontFamily}`;
        textCtx.textAlign = "center";
        textCtx.textBaseline = "middle";

        const tX = (labelData.pos.x / 100) * canvasWidth;
        const tY = (labelData.pos.y / 100) * canvasHeight;
        const tAngle = labelData.pos.angle || 0;

        textCtx.save();
        textCtx.translate(tX, tY);
        textCtx.rotate((tAngle * Math.PI) / 180);
        textCtx.scale(scaleX, scaleY);

        if (
          labelData.backgroundColor &&
          labelData.backgroundColor !== "transparent" &&
          labelData.backgroundColor !== "rgba(0, 0, 0, 0)" &&
          labelData.backgroundColor !== "#00000000"
        ) {
          const metrics = textCtx.measureText(labelData.text);
          const textWidth = metrics.width;
          const textHeight = labelData.fontSize;
          const padding = 8;

          textCtx.fillStyle = labelData.backgroundColor;
          textCtx.fillRect(
            -textWidth / 2 - padding / 2,
            -textHeight / 2 - padding / 2,
            textWidth + padding,
            textHeight + padding,
          );
        }

        textCtx.fillStyle = labelData.color;
        textCtx.fillText(labelData.text, 0, 0);
        textCtx.restore();

        children.push({
          name: "Serial Number",
          canvas: textCanvas,
          left: 0,
          top: 0,
        });
      }

      const psd = {
        width: canvasWidth,
        height: canvasHeight,
        children: children,
      };

      const buffer = writePsd(psd);
      return buffer;
    },

    async processAndDownload() {
      if (!this.canExport) return;
      this.isProcessing = true;

      try {
        let frontCustomLayers = [];
        let backCustomLayers = [];
        
        // 1. فقط گرفتن لایه‌های سفارشی قبل از حلقه
        if (this.frontBg && this.$refs.frontEditor) {
          frontCustomLayers = Array.isArray(this.$refs.frontEditor)
            ? this.$refs.frontEditor[0].getCustomLayers()
            : this.$refs.frontEditor.getCustomLayers();
        }
        
        if (this.backBg && this.$refs.backEditor) {
          backCustomLayers = Array.isArray(this.$refs.backEditor)
            ? this.$refs.backEditor[0].getCustomLayers()
            : this.$refs.backEditor.getCustomLayers();
        }

        const zip = new JSZip();
        let frontFolder = null;
        let backFolder = null;

        if (this.frontBg) frontFolder = zip.folder("Front-Cards");
        if (this.backBg) backFolder = zip.folder("Back-Cards");

        const mimeType = this.exportFormat === "png" ? "image/png" : "image/jpeg";

        // 2. شروع حلقه برای تولید فایل‌ها
        for (let i = 0; i < this.qrImages.length; i++) {
          const currentQrUrl = this.qrImages[i].url;
          const fileName = `card_${i + 1}.${this.exportFormat}`;
          const serialNumber = this.extractNumberFromFileName(
            this.qrImages[i].name || currentQrUrl,
            this.labelConfig.usePersianDigits,
          );
          const currentLabelDataFront = {
            ...this.labelConfig,
            text: serialNumber,
            pos: this.frontLabelPos,
          };
          const currentLabelDataBack = {
            ...this.labelConfig,
            text: serialNumber,
            pos: this.backLabelPos,
          };

          // --- خروجی جلوی کارت ---
          if (this.frontBg && frontFolder) {
            if (this.exportFormat === "psd") {
              const buffer = await this.generatePsdBuffer(
                this.frontBg,
                currentQrUrl,
                this.frontConfig,
                frontCustomLayers,
                currentLabelDataFront,
              );
              frontFolder.file(fileName, buffer);
            } else if (this.exportFormat === "dxf") {
              // استفاده از متد تبدیل base64 به dxf که نوشتید
              let base64DataUrl = await this.generateStandardImageBase64(
                this.frontBg,
                currentQrUrl,
                this.frontConfig,
                "image/png",
                frontCustomLayers,
                currentLabelDataFront
              );
              base64DataUrl = await this.applyOutputFormatting(base64DataUrl, "image/png");
              const dxfContent = await this.generateDxfFromBase64(base64DataUrl);
              frontFolder.file(`card_${i + 1}.dxf`, dxfContent);
            } else {
              let base64DataUrl = await this.generateStandardImageBase64(
                this.frontBg,
                currentQrUrl,
                this.frontConfig,
                mimeType,
                frontCustomLayers,
                currentLabelDataFront,
              );
              base64DataUrl = await this.applyOutputFormatting(base64DataUrl, mimeType);
              const base64Content = base64DataUrl.split(",")[1];
              frontFolder.file(fileName, base64Content, { base64: true });
            }
          }

          // --- خروجی پشت کارت ---
          if (this.backBg && backFolder) {
            if (this.exportFormat === "psd") {
              const buffer = await this.generatePsdBuffer(
                this.backBg,
                currentQrUrl,
                this.backConfig,
                backCustomLayers,
                currentLabelDataBack,
              );
              backFolder.file(fileName, buffer);
            } else if (this.exportFormat === "dxf") {
              let base64DataUrl = await this.generateStandardImageBase64(
                this.backBg,
                currentQrUrl,
                this.backConfig,
                "image/png",
                backCustomLayers,
                currentLabelDataBack
              );
              base64DataUrl = await this.applyOutputFormatting(base64DataUrl, "image/png");
              const dxfContent = await this.generateDxfFromBase64(base64DataUrl);
              backFolder.file(`card_${i + 1}.dxf`, dxfContent);
            } else {
              let base64DataUrl = await this.generateStandardImageBase64(
                this.backBg,
                currentQrUrl,
                this.backConfig,
                mimeType,
                backCustomLayers,
                currentLabelDataBack,
              );
              base64DataUrl = await this.applyOutputFormatting(base64DataUrl, mimeType);
              const base64Content = base64DataUrl.split(",")[1];
              backFolder.file(fileName, base64Content, { base64: true });
            }
          }
        }

        const zipContent = await zip.generateAsync({ type: "blob" });
        saveAs(zipContent, "Batch_Cards.zip");
        
      } catch (error) {
        console.error("خطا در تولید خروجی گروهی:", error);
        this.$toast.error("خطایی در فرآیند تولید تصاویر رخ داد.");
      } finally {
        this.isProcessing = false;
        this.dialogExport = false;
      }
    }

  },
};
</script>

<style scoped>
.transparent-bg {
  background-color: transparent !important;
}
.v-expansion-panel {
  border-radius: 15px !important;
  box-shadow: 8px 5px 10px #f49d1a;
}
.v-expansion-panel
  >>> .v-expansion-panel-header.v-expansion-panel-header--active {
  background-color: #001554 !important;
  border-radius: 15px !important;
  color: whitesmoke !important;
}
.v-expansion-panel
  >>> .v-expansion-panel-header.v-expansion-panel-header--active
  .v-icon {
  color: whitesmoke !important;
}
.submit-btn {
  border-radius: 10px;
  font-weight: bold;
}
</style>
